import { createFileRoute } from "@tanstack/react-router";
import { CityLandingPage, buildCityLandingHead, type CityLandingConfig } from "@/components/CityLandingPage";

const CONFIG: CityLandingConfig = {
  slug: "fountain",
  name: "Fountain",
  region: "South El Paso County",
  heroEyebrow: "Fountain Marketing Hub",
  heroTitle: { lead: "Fountain marketing for ", gold: "South Springs", trail: " businesses" },
  heroDescription:
    "Fountain, Security-Widefield, and the south I-25 corridor are one of Colorado's fastest-growing markets — Fort Carson PCS turnover, new construction, and 30,000+ residents who Google before they call. We build websites and SEO for trades and services that want this market locked down.",
  intro:
    "Fountain demand is driven by Fort Carson — constant PCS turnover means brand-new households with zero existing provider relationships, searching daily for HVAC, plumbers, movers, dentists, and auto. The shops that show up first in the Fountain Map Pack win these customers for years.",
  neighborhoods: [
    "Downtown Fountain",
    "Security",
    "Widefield",
    "Cross Creek",
    "Mesa Ridge",
    "Fountain Mesa",
    "Cimarron Hills",
    "Fort Carson-adjacent",
  ],
  marketSnapshot:
    "Fountain's Map Pack faces Springs spillover and a handful of dedicated south-side operators. National franchises bid hard on PCS-intent keywords. Wins come from a Fountain-specific page, real local reviews, and fast site speed for mobile-heavy military households.",
  highlights: [
    {
      title: "PCS-cycle content built in",
      body: "Fort Carson PCS waves drive predictable spikes in 'movers Fountain', 'HVAC service Security-Widefield', and 'dentist near Fort Carson' searches. We build content tuned to the PCS calendar so you catch the wave instead of chasing it.",
    },
    {
      title: "Fountain-specific Map Pack work",
      body: "A Colorado Springs page doesn't rank well in Fountain searches. We build a dedicated Fountain landing page, GBP service area, and review velocity so you own the south-side 3-pack.",
    },
    {
      title: "Mobile-first for military households",
      body: "PCS searches happen on phones, often before the household has wifi set up. Sub-1MB builds and fast contact forms convert at 2–3× slow franchise sites.",
    },
  ],
  services: [
    { to: "/colorado-springs-seo", title: "SEO", body: "Fountain and Security-Widefield Map Pack rankings, on-page depth, and review velocity tuned to PCS turnover." },
    { to: "/colorado-springs-web-design", title: "Web design", body: "Fast, mobile-first sites built to convert military households who search before they call." },
    { to: "/colorado-springs-google-maps", title: "Google Maps", body: "GBP setup, posts, photos, and review programs to win the Fountain 3-pack." },
    { to: "/colorado-springs-ppc", title: "Google Ads", body: "PCS-targeted Google Ads that catch new-arrival households in their first 30 days at Fort Carson." },
  ],
  learnArticleSlugs: [
    "/learn/local-seo-guide",
    "/learn/google-business-profile",
    "/learn/get-more-reviews",
    "/learn/google-ads-vs-seo-colorado",
    "/learn/website-conversion",
    "/learn/marketing-budget",
  ],
  learnIntro:
    "Fountain owners win by capturing PCS-driven, search-first demand before national franchises do. These six pieces explain how.",
  closingCta:
    "30-minute call. We'll audit your Fountain Map Pack position, look at the national franchises bidding on Fort Carson, and tell you what to fix first.",
};

export const Route = createFileRoute("/fountain")({
  head: () =>
    buildCityLandingHead(CONFIG, {
      metaTitle: "Fountain Marketing Agency | SEO, Web Design & Maps | CWI",
      metaDescription:
        "Fountain and Security-Widefield SEO, web design, and Google Maps optimization for the Fort Carson corridor. Local Colorado team, transparent reporting, no long-term contracts.",
    }),
  component: () => <CityLandingPage config={CONFIG} />,
});
